<template lang="pug">
  .tasks-list(v-if="$props.tasks && $props.tasks.length")
    <tasks-list-item v-for="task in $props.tasks" v-bind:task="task" v-bind:key="task.id"></tasks-list-item>
</template>
<script>
  import moment from "moment";
  import TasksListItem from '@/components/TasksListItem';
  export default {
    name: 'tasks-list',
    components: {TasksListItem},
    props: {
        tasks: {
            type: Array,
            default: []
        }
    },
    data() {
      return {
      }
    },
    created() {
    },
    watch: {
    },
    computed: {

    },
    methods: {

    }
  }
</script>
<style scoped lang="sass">
</style>



// WEBPACK FOOTER //
// TasksList.vue?eb05c0ba